import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContentPreview = ({ contentType, content }) => {
  const surpriseTypeLabels = {
    video: 'Video İçerik',
    image: 'Görsel İçerik',
    quiz: 'Hızlı Quiz',
    story: 'Hikaye',
    challenge: 'Özel Meydan Okuma',
    custom: 'Özel İçerik'
  };

  const renderPreview = () => {
    switch (contentType) {
      case 'daily-message':
        return (
          <div className="space-y-4">
            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
              {content?.title || 'Başlık girilmedi'}
            </h3>
            <p className="text-foreground leading-relaxed">
              {content?.message || 'Mesaj içeriği girilmedi'}
            </p>
            <Button variant="default" size="default" iconName="Share2" iconPosition="left">
              Instagram Stories'de Paylaş
            </Button>
          </div>
        );

      case 'mini-task':
        return (
          <div className="space-y-4">
            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
              {content?.title || 'Başlık girilmedi'}
            </h3>
            <p className="text-foreground leading-relaxed">
              {content?.description || 'Görev açıklaması girilmedi'}
            </p>
            <Button variant="success" size="default" iconName="Check" iconPosition="left">
              Yaptım
            </Button>
          </div>
        );

      case 'poll':
        return (
          <div className="space-y-4">
            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
              {content?.question || 'Anket sorusu girilmedi'}
            </h3>
            <div className="space-y-3">
              {(content?.options || ['Seçenek 1', 'Seçenek 2', 'Seçenek 3'])?.map((option, index) => (
                <div
                  key={index}
                  className="p-4 rounded-lg border-2 border-border bg-card"
                >
                  <span className="text-foreground">{option || `Seçenek ${index + 1}`}</span>
                </div>
              ))}
            </div>
          </div>
        );

      case 'humor':
        return (
          <div className="space-y-4">
            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
              {content?.title || 'Başlık girilmedi'}
            </h3>
            <p className="text-foreground leading-relaxed">
              {content?.content || 'Eğlence içeriği girilmedi'}
            </p>
            <div className="flex gap-3 flex-wrap">
              {['😂', '😊', '👍', '❤️', '🔥']?.map((emoji, index) => (
                <button
                  key={index}
                  className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-muted border border-border flex items-center justify-center text-xl md:text-2xl hover:bg-accent/10 transition-colors"
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
        );

      case 'giveaway':
        return (
          <div className="space-y-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Gift" size={20} color="var(--color-destructive)" />
              <span className="caption text-destructive font-medium">
                {content?.isActive ? 'Aktif Çekiliş' : 'Pasif Çekiliş'}
              </span>
            </div>
            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
              {content?.title || 'Başlık girilmedi'}
            </h3>
            <p className="text-foreground leading-relaxed">
              {content?.description || 'Çekiliş açıklaması girilmedi'}
            </p>
            <div className="p-4 rounded-lg bg-accent/10 border border-accent/20">
              <p className="caption text-foreground">
                <strong>Hediye:</strong> {content?.prize || 'Belirtilmedi'}
              </p>
              <p className="caption text-foreground mt-1">
                <strong>Çekiliş Tarihi:</strong> {content?.drawDate || 'Belirtilmedi'}
              </p>
            </div>
            <Button variant="default" size="default" iconName="Gift" iconPosition="left">
              Çekilişe Katıl
            </Button>
          </div>
        );

      case 'social-awareness':
        return (
          <div className="space-y-4">
            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
              {content?.title || 'Başlık girilmedi'}
            </h3>
            <p className="text-foreground leading-relaxed">
              {content?.message || 'Kampanya mesajı girilmedi'}
            </p>
            {content?.callToAction && (
              <p className="text-sm text-muted-foreground italic">
                {content?.callToAction}
              </p>
            )}
            <Button variant="default" size="default" iconName="Heart" iconPosition="left">
              Katılıyorum
            </Button>
          </div>
        );

      case 'surprise':
        return (
          <div className="space-y-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Sparkles" size={20} color="var(--color-accent)" />
              <span className="caption text-accent font-medium">
                {content?.surpriseType ? surpriseTypeLabels?.[content?.surpriseType] : 'Sürpriz'}
              </span>
            </div>
            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
              {content?.title || 'Başlık girilmedi'}
            </h3>
            <p className="text-foreground leading-relaxed">
              {content?.content || 'Sürpriz içeriği girilmedi'}
            </p>
          </div>
        );

      default:
        return (
          <div className="text-center py-12">
            <Icon name="FileQuestion" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
            <p className="text-muted-foreground">
              İçerik önizlemesi için bir içerik tipi seçin
            </p>
          </div>
        );
    }
  };

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
          <Icon name="Eye" size={20} color="var(--color-accent)" />
        </div>
        <div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            İçerik Önizlemesi
          </h3>
          <p className="caption text-muted-foreground">
            Kullanıcıların göreceği görünüm
          </p>
        </div>
      </div>

      <div className="p-6 md:p-8 rounded-xl bg-background border-2 border-dashed border-border">
        {renderPreview()}
      </div>
    </div>
  );
};

export default ContentPreview;